<template>
  <v-dialog v-model="show" :max-width="dialogWidth" scrollable persistent>
    <v-card elevation="5" class="rounded-lg">
      <v-card-title class="headline primary white--text">
        Solicitud de nuevo Bioensayo
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-4">
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row>
              <v-col md="6">
                <div class="mb-4">
                  <span class="text-body-1 font-weight-bold"
                    >Proyecto asociado:</span
                  >
                  <v-chip color="primary" class="ml-2">
                    {{ projectName }}
                  </v-chip>
                </div>
                <div>
                  <span class="text-caption grey--text">Tipo de proyecto:</span>
                  <div class="text-body-2">
                    {{ getProyectType(projectType) }}
                  </div>
                </div>
              </v-col>

              <v-col md="6">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="packageName"
                      dense
                      outlined
                      clearable
                      label="Nombre de paquete"
                      :rules="validation()"
                      prepend-inner-icon="mdi-package-variant"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="packageVersion"
                      dense
                      outlined
                      clearable
                      label="Versión"
                      :rules="validation()"
                      prepend-inner-icon="mdi-numeric"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Product selection section -->
            <v-row class="mt-2">
              <v-col cols="12">
                <v-subheader class="pl-0">
                  <span class="font-weight-bold">Productos disponibles</span>
                  <v-spacer></v-spacer>
                  <span class="text-caption"
                    >(Seleccionados: {{ selectedProducts.length }})</span
                  >
                </v-subheader>

                <v-card outlined class="rounded-lg">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          v-model="selectAll"
                          @click="toggleSelectAll"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold"
                          >Seleccionar todos</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <template v-for="(product, index) in productList">
                      <v-list-item :key="product._id">
                        <v-list-item-action>
                          <v-checkbox
                            v-model="selectedProducts"
                            :value="product._id"
                            color="primary"
                            hide-details
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{
                            product.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle class="text-caption">
                            <v-chip
                              x-small
                              label
                              class="mr-1"
                              v-if="product.type"
                            >
                              {{ product.type }}
                            </v-chip>
                            <v-chip
                              x-small
                              label
                              class="mr-1"
                              v-if="product.lot"
                            >
                              Lote: {{ product.lot }}
                            </v-chip>
                            <v-chip x-small label v-if="product.expirationDate">
                              Exp: {{ formatDate(product.expirationDate) }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-btn
                            icon
                            small
                            @click="handleProductSelected(product._id)"
                          >
                            <v-icon small>mdi-information</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>

                      <v-divider
                        v-if="index < productList.length - 1"
                        :key="`divider-${index}`"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="error"
                block
                @click="closeModal"
                :disabled="loading"
                outlined
              >
                <v-icon left>mdi-cancel</v-icon>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="loading"
                :disabled="selectedProducts.length === 0"
              >
                <v-icon left>mdi-check</v-icon>
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <ProductModal
      v-model="showProductModal"
      v-if="showProductModal"
      @close="handleProductClose"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";
// components
import ProductModal from "../../products/modals/ProductModal.vue";
export default {
  components: {
    ProductModal,
  },
  data: () => ({
    project: null,
    projectName: null,
    projectType: null,
    loading: false,
    packageName: null,
    packageVersion: null,
    productList: [],
    selectedProducts: [], // Array to store selected product IDs
    selectAll: false, // Control for select all checkbox
    showProductModal: false,
  }),
  props: {
    value: Boolean,
    markers: Array,
  },
  computed: {
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) return "90vw";
      if (this.$vuetify.breakpoint.sm) return "70vw";
      if (this.$vuetify.breakpoint.md) return "60vw";
      return "40vw";
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    if (this.markers.length > 0) {
      console.log(this.markers);
      
      for (const marker of this.markers) {
        if (
          marker.project &&
          typeof marker.project == "object" &&
          !this.project
        ) {
          this.project = marker.project;
          this.projectName = marker.project.projectName;
          this.projectType = marker.project.type;
        }
        if (marker.packageName && !this.packageName) {
          this.packageName = marker.packageName;
        }
        if (marker.packageVersion && !this.packageVersion) {
          this.packageVersion = marker.packageVersion;
        }
      }
    }
    // fetch products
    await this.fetchProducts();
  },
  methods: {
    ...mapActions("bioassays", ["addBioassay"]),
    ...mapActions("products", ["getProducts"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("bioassays", ["SET_PRODUCT_ID"]),
    closeModal() {
      this.show = false;
    },

    validation(name) {
      return requiredValidation(name);
    },

    async confirmation() {
      if (this.$refs.form.validate() && this.selectedProducts.length > 0) {
        try {
          this.loading = true;

          let payload = {
            project: this.project,
            molecularMarkers: this.markers.map((marker) => marker._id),
            selectedProducts: this.selectedProducts, // Include selected products in payload
            packageName: this.packageName,
            packageVersion: this.packageVersion,
          };
          await this.addBioassay(payload);

          this.$refs.form.reset();
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Solicitud enviada con éxito`,
            timeout: 5000,
          });
          this.$emit("close_and_clean");
        } catch (error) {
          console.log(error);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: `Algo salió mal. Error: ${error.message}`,
            timeout: 5000,
          });
        } finally {
          this.loading = false;
        }
      }
    },

    getProyectType(type) {
      let typeEnum = {
        MISS_SETUP: "Miss Setup",
      };
      return typeEnum[type] || type;
    },

    async fetchProducts() {
      try {
        let payload = {
          projectId: this.project._id,
        };
        let response = await this.getProducts(payload);
        this.productList = response.products;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      }
    },

    // Toggle select all products
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedProducts = this.productList.map((product) => product._id);
      } else {
        this.selectedProducts = [];
      }
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },

    // Show product details in dialog
    handleProductSelected(productId) {
      this.SET_PRODUCT_ID(productId);
      this.showProductModal = true;
    },

    // Hide product details in dialog
    handleProductClose() {
      this.showProductModal = false;
      this.SET_PRODUCT_ID(null);
    },
  },
  watch: {
    // Watch selected products to update select all checkbox
    selectedProducts(newVal) {
      this.selectAll = newVal.length === this.productList.length;
    },
  },
};
</script>

<style scoped>
/* Custom styles for better visual hierarchy */
.v-card-title {
  padding: 16px 24px;
}

.v-card-text {
  padding: 16px 24px;
}

.v-list-item__action {
  min-width: 36px;
}

/* Make chips more compact */
.v-chip {
  height: 20px;
  font-size: 0.65rem;
}
</style>
